
import Vue from "vue";


Vue.directive('inputFilter', {
    inserted(el, vDir, vNode) {
        el.onpaste = function (e) {
            e.preventDefault();
        }
        // const vDir = {...vDirB}
        // vDir.value 有指令的参数
        let content
        // 设置输入框的值,触发input事件,改变v-model绑定的值
        const setVal = val => {
            if (vNode.componentInstance) {
                console.log(22222,);
                // 如果是自定义组件就触发自定义组件的input事件
                vNode.componentInstance.$emit('input', val)
            } else {
                console.log(333333);
                // 如果是原生组件就触发原生组件的input事件
                el.value = val
                el.dispatchEvent(new Event('input'))
            }
        }

        // 按键按下=>只允许输入 数字/小数点/减号
        el.addEventListener('keypress', event => {
            const e = event || window.event
            const inputKey = String.fromCharCode(typeof e.charCode === 'number' ? e.charCode : e.keyCode)
            const re = vDir.value.precision === 0 ? /\d/ : /\d|\.|-/

            // const reFloat = /([0-9]+\.[0-9]{2})[0-9]*/;
            content = e.target.value

            // 定义方法,阻止输入
            function preventInput() {
                if (e.preventDefault) {
                    e.preventDefault()
                } else {
                    e.returnValue = false
                }
            }

            if (!re.test(inputKey) && !e.ctrlKey) {
                console.log(5555555, content);
                // Vue.prototype.$message.warning('请输入英文的小数点')
                preventInput()
            } else if (content.indexOf('.') > 0 && inputKey === '.') {
                console.log(333, 4444);
                // 已有小数点,再次输入小数点
                preventInput()
            } else if (content.indexOf('.') > 0) {
                const newContent = String(content).split('.')
                if (newContent[1].length >= parseFloat(vDir.value.precision)) {
                    preventInput()
                }
            }
        })
        // 按键弹起=>并限制最大最小
        el.addEventListener('keyup', event => {
            const e = event || window.event
            content = parseFloat(e.target.value)

            if (e.target.value == '-') {

                content = parseFloat(e.target.value)
                if (parseFloat(vDir.value.min) >= 0) {
                    if (isNaN(content)) {
                        setVal('')
                    }
                }
            } else {
                if (isNaN(e.target.value)) {
                    if (isNaN(parseFloat(e.target.value))) {
                        setVal('')
                    } else {
                        setVal(parseFloat(e.target.value))
                    }
                }
            }
            if (!content) {
                // console.log("nidaye");
                // content = 0.00
            }
            let arg_max = ''
            let arg_min = ''
            if (vDir.value) {
                arg_max = parseFloat(vDir.value.max)
                // eslint-disable-next-line
                arg_min = parseFloat(vDir.value.min)
            }
            if (arg_max !== undefined && content > arg_max) {
                setVal(arg_max)
                content = arg_max
            }
        })
        // 失去焦点=>保留指定位小数
        el.addEventListener('focusout', event => { // 此处会在 el-input 的 @change 后执行

            const e = event || window.event
            content = parseFloat(e.target.value)
            if (isNaN(content)) {
                setVal('')
                return
            }
            if (content != '' && !isNaN(content)) {
                setVal(content)
            }
            if (content === 0) {
                setVal(0)
            }
            let arg_min = ''
            if (vDir.value) {
                arg_min = parseFloat(vDir.value.min)
            }
            if (arg_min !== undefined && (content !== '') && content < arg_min) {
                setVal(arg_min)
                content = arg_min
            }
            if (vDir.value.isPrecisionFormat) {
                let arg_precision = 0// 默认保留至整数
                if (vDir.value.precision) {
                    arg_precision = parseFloat(vDir.value.precision)
                }
                e.target.value = content.toFixed(arg_precision)
                setVal(e.target.value)
            }



            // -- callback写法1
            // vNode.data.model.callback = ()=>{
            //     e.target.value = content.toFixed(arg_precision)
            // }
            // vNode.data.model.callback();
            // -- callback 写法2
            // vNode.data.model.callback(
            //     e.target.value = content.toFixed(arg_precision)
            // )
        })
    }
})

Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        console.log('wl')
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden');
        });
    }
});

